import { billingPeriod } from 'utilities/billing_period';
import { formatPrice } from 'utilities/money';

import { OfferProps } from '@marketing/types';

// A recurring plan's price pays for one billing period, so say which
export const periodSuffix = (offer: OfferProps) => (
  offer.recurring ? ` / ${billingPeriod(offer)}` : ''
);

// An offer's price the way the marketing pages quote it, e.g. '$199' or '$30 / month'. Quotes the
// price without the sale unless given another.
export const formatOfferPrice = (offer: OfferProps, priceInCents = offer.fullPriceInCents) => (
  `${formatPrice(priceInCents, 'usd', true)}${periodSuffix(offer)}`
);
